import { z } from "zod";
import {
  RibDataSchema,
  RibContextSchema,
  RibExtractionSchema,
  type RibData,
} from "../../../document/document-types/rib";
import type { FieldMessages } from "../../../document/types";
import { createFieldMessagesSchema } from "../../../document/schema";
import { storeResponseSchema } from "../base";
import type { DocumentTypeSchemas } from "../types";

// ===== Internal schemas (not exported) =====

const fieldMessagesSchema = createFieldMessagesSchema(RibDataSchema);

const warnRequestSchema = z.object({
  data: RibDataSchema.partial(),
  context: RibContextSchema,
});

const validateRequestSchema = z.object({
  data: RibDataSchema.partial(),
  context: RibContextSchema,
});

// ===== Exported types (for API client) =====

export type ExtractResponse = z.infer<typeof RibExtractionSchema>;
export type WarnRequestBody = z.infer<typeof warnRequestSchema>;
export type WarnResponse = FieldMessages<RibData>;
export type ValidateRequestBody = z.infer<typeof validateRequestSchema>;
export type ValidateResponse = FieldMessages<RibData>;
export type StoreResponse = z.infer<typeof storeResponseSchema>;

// ===== Exported bundle (source of truth for route registration) =====

export const RibSchemas = {
  extractResponse: RibExtractionSchema,
  warnRequest: warnRequestSchema,
  warnResponse: fieldMessagesSchema,
  validateRequest: validateRequestSchema,
  validateResponse: fieldMessagesSchema,
  storeResponse: storeResponseSchema,
} satisfies DocumentTypeSchemas;
